import { Button, Flex, Icon, IconButton, Menu, MenuButton } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import { FC } from 'react';
import { iconTableStyle, tableToolbarStyle } from 'shared/styles';
import { TKeywordCategories } from './useKeywordCategories';
import { intentionalyFloatingPromiseReturn } from 'utils/wrappers';
import icons from 'shared/icons';

interface ICategoriesToolbarProps {
    handleEditCategories: () => void;
    isDisabled: boolean;
    handleExportKeywordCategories: TKeywordCategories['handleExportKeywordCategories'];
    isExportLoading: boolean;
    isFetching: boolean;
}

const CategoriesToolbar: FC<ICategoriesToolbarProps> = ({
    handleEditCategories,
    isDisabled,
    handleExportKeywordCategories,
    isExportLoading,
    isFetching,
}) => {
    const DownloadIcon = icons.download;
    const translate = useTranslation();
    return (
        <Flex {...tableToolbarStyle}>
            <Button
                {...iconTableStyle}
                aria-label="Associate Keywords"
                size="sm"
                onClick={handleEditCategories}
                isDisabled={isDisabled}
            >
                {translate('categories_keywords.column.associate_keywords')}
            </Button>
            <IconButton
                {...iconTableStyle}
                aria-label="download excel"
                isLoading={isExportLoading || isFetching}
                onClick={intentionalyFloatingPromiseReturn(handleExportKeywordCategories)}
                size="sm"
                icon={<DownloadIcon />}
            />
        </Flex>
    );
};

export default CategoriesToolbar;
